import { Navigate, useParams } from 'react-router-dom';

/** Compat: `/loja/x` → `/{slug}` na raiz */
export function LegacyLojaRedirect() {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/" replace />;
  return <Navigate to={`/${slug}`} replace />;
}
